/**
 * /research/rocketreach — "RocketReach → Thrive" bookmarklet tool page.
 * Config wrapper over the shared `BookmarkletToolPage` template.
 */
import { BookmarkletToolPage } from "./BookmarkletToolPage";
import { ROCKETREACH_BOOKMARKLET } from "./rocketreachBookmarklet";

export function RocketReachTool() {
  return (
    <BookmarkletToolPage
      testId="tool-rocketreach"
      breadcrumbSection="Research & Sourcing"
      title="RocketReach → Thrive"
      subtitle="Use a bookmarklet to one-click copy contact information from RocketReach into Thrive — no manual copy-paste."
      whatItDoes="While you're viewing a contact in Thrive, you click the RocketReach bookmarklet to open RocketReach, click on edit the Thrive Contact, copy that person's contact information (name, email, phone, company) from RocketReach to Thrive. You then just click Save if it looks good."
      bookmarklet={ROCKETREACH_BOOKMARKLET}
      inAppClickHint="Drag this button to your bookmarks bar to install — it runs on a RocketReach contact page, not here."
      howToSteps={[
        { id: "open", content: "Open a contact's page in Thrive." },
        {
          id: "click",
          content: (
            <>
              Click the bookmarklet (whatever you named it) in your bookmarks bar. The bookmarklet opens RocketReach, clicks on edit the Thrive Contact, copies that person's contact information (name, email, phone, company) from RocketReach to Thrive.
            </>
          ),
        },
        { id: "done", content: "You then click Save if it looks good." },
      ]}
      training={{
        url: "https://drive.google.com/file/d/1DA9bc6f2sLLG9fJReyBMAWpJwheuAIV3/view",
        label: "Watch: How to install & use the RocketReach → Thrive bookmarklet",
        note: "Google Drive video",
      }}
    />
  );
}
